import { AlertProps } from "@jugl-web/ui-components/cross-platform/Alert";
import { createContext } from "react";

export interface UIComponentsContextType {
  showAlert: (
    options: Omit<AlertProps, "isOpen" | "onRequestClose"> & {
      onClosed?: () => void;
    }
  ) => void;
}

export const UIComponentsContext = createContext<
  UIComponentsContextType | undefined
>(undefined);
